export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  ANNOUNCEMENTS_CHANGED: 'ANNOUNCEMENTS_CHANGED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  CLOUDCHAT_SUPPORT_ACTIVATE: 'cloudchatSupportActivate',
  CLOUDCHAT_SUPPORT_SLOT_CHANGED: 'cloudchatSupportSlotChanged',
  CLAUDIA_PROJECTS_CHANGED: 'claudiaProjectsChanged',
  CANNY_CHANGELOG_TRIGGER_MOUNTED: 'cannyChangelogTriggerMounted',
  VOICE_CALL_ANSWERED: 'voiceCallAnswered',
  VOICE_CALL_STARTED: 'voiceCallStarted',
  VOICE_CALL_ENDED: 'voiceCallEnded',
  VOICE_SOFTPHONE_OPEN: 'voiceSoftphoneOpen',
};
